module.exports = __webpack_public_path__ + "img/icon-card.f0a9a253.svg";